import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import {
  applyPwaUpdate,
  getNeedRefresh,
  pwaEvents,
} from '@/register-sw'

const PwaUpdatePrompt = () => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(getNeedRefresh)
  const [updating, setUpdating] = useState(false)

  useEffect(() => {
    const onNeedRefresh = () => setOpen(true)
    pwaEvents.addEventListener('need-refresh', onNeedRefresh)
    return () => pwaEvents.removeEventListener('need-refresh', onNeedRefresh)
  }, [])

  const handleUpdate = () => {
    setUpdating(true)
    applyPwaUpdate()
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
    >
      <Alert
        sx={{ width: '100%' }}
        color="success"
        severity="info"
        onClose={() => setOpen(false)}
        action={
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            disabled={updating}
            onClick={handleUpdate}
          >
            {t('reload')}
          </Button>
        }
      >
        {t('pwa_update_available')}
      </Alert>
    </Snackbar>
  )
}

export default PwaUpdatePrompt
